import { createAsyncThunk } from '@reduxjs/toolkit';
import { notification } from 'antd';

import * as API from '../api/index.js';
import { selectPerPage } from '../selectors/general.js';
import { canCreateEventByDateRange } from './helper.js';
import { fetchTeamEvents } from './calendarThunks.js';
import { fetchCurrentBalance, fetchBalanceHistory } from './balanceThunks.js';

export const fetchVacations = createAsyncThunk('vacations/fetch', async ({ page }, { getState, rejectWithValue }) => {
    try {
        const perPage = selectPerPage(getState());
        const { vacationsWithApprovers, maxPageNumber } = await API.vacations.get(page, perPage);
        const { list } = getState().vacation;

        return {
            maxPageNumber,
            list: page ? [...list, ...vacationsWithApprovers] : vacationsWithApprovers,
        };
    } catch (error) {
        notification.error({ message: 'Error', description: error.message || 'Server error' });
        return rejectWithValue(error.message);
    }
});

export const createVacation = createAsyncThunk('vacations/create', async ({ data }, { dispatch, rejectWithValue }) => {
    try {
        await canCreateEventByDateRange(data.startDate, data.endDate);
        const created = await API.vacations.create(data);
        notification.info({ message: 'Success', description: 'Vacation was created' });

        dispatch({ type: 'general/toggleModal', payload: { modal: 'vacation', isOpen: false } });

        dispatch(fetchTeamEvents());
        dispatch(fetchCurrentBalance());
        dispatch(fetchBalanceHistory({ page: 0 }));

        return created;
    } catch (error) {
        notification.error({ message: 'ERROR', description: error.message });
        return rejectWithValue(error.message);
    }
});

export const updateVacation = createAsyncThunk(
    'vacations/update',
    async ({ id, data }, { dispatch, rejectWithValue }) => {
        try {
            await canCreateEventByDateRange(data.startDate, data.endDate, id);
            const updated = await API.vacations.update(id, data);

            dispatch({ type: 'general/toggleModal', payload: { modal: 'vacationEdit', isOpen: false } });

            notification.info({ message: 'Success', description: 'Vacation was updated' });

            dispatch(fetchTeamEvents());
            dispatch(fetchCurrentBalance());
            dispatch(fetchBalanceHistory({ page: 0 }));

            return updated;
        } catch (error) {
            notification.error({ message: 'ERROR', description: error.message });
            return rejectWithValue(error.message);
        }
    },
);

export const deleteVacation = createAsyncThunk('vacations/delete', async ({ id }, { dispatch, rejectWithValue }) => {
    try {
        await API.vacations.remove(id);
        notification.info({ message: 'Success', description: 'Vacation was deleted' });

        dispatch(fetchTeamEvents());
        dispatch(fetchCurrentBalance());
        dispatch(fetchBalanceHistory({ page: 0 }));

        return id;
    } catch (error) {
        notification.error({ message: 'ERROR', description: error.message });
        return rejectWithValue(error.message);
    }
});
